import { Maximize2, Minimize2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useFocusMode } from '@/contexts/FocusModeContext';
import { cn } from '@/lib/utils';

export const FloatingFocusButton = ({ inline = false }: { inline?: boolean }) => {
  const { isFocusMode, toggleFocusMode } = useFocusMode();
  const label = isFocusMode ? 'Exit focus mode' : 'Enter focus mode';
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant={inline ? 'ghost' : 'outline'}
          size={inline ? 'sm' : 'icon'}
          onClick={toggleFocusMode}
          aria-label={label}
          aria-pressed={isFocusMode}
          className={cn(
            inline
              ? 'h-8 min-h-0 gap-2 px-2'
              : 'fixed right-2 top-2 z-40 h-8 min-h-0 w-8 min-w-0 rounded-lg bg-popover shadow-sm',
            isFocusMode && 'bg-primary text-primary-foreground hover:bg-primary/90'
          )}
        >
          {isFocusMode ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
          {inline && (
            <span className="hidden min-[1100px]:inline">
              {isFocusMode ? 'Exit focus' : 'Focus'}
            </span>
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
};
